// ──────────────────────────────────────────────────────────────────────────────
// Auto-generated by scripts/generate-build-info.mjs
// Do NOT edit manually — this file is overwritten on every build.
// ──────────────────────────────────────────────────────────────────────────────

export const BUILD_INFO = {
  /** Semver version from package.json */
  version: "0.9.0",
  /** Short git commit hash (7 chars) */
  commit: "82c9438",
  /** ISO 8601 build timestamp */
  builtAt: "2026-08-01T20:48:38.159Z",
  /** Compact display label: "v1.0.0 • a3f91bc" */
  label: "v0.9.0 • 82c9438",
} as const

export type BuildInfo = typeof BUILD_INFO
